// extracted by mini-css-extract-plugin
export var bodySections = "_b9-8";
export var gray = "_b9-7";
export var green = "_b9-4";
export var iconContainer = "_b9-9";
export var iconWidgetContainer = "_b9-1";
export var phoneIcon = "_b9-2";
export var red = "_b9-5";
export var statusDot = "_b9-3";
export var widgetContainer = "_b9-0";
export var yellow = "_b9-6";